import * as actionType from '../actionTypes';
const initialState = {
    localization_languages: [],
    default_languages: 'us_en'
}
// Reducer for handling actions of localization and save them to redux state
const localizationReducer = (state =initialState, action) =>{
    switch( action.type ){
        case actionType.LOAD_LANGUAGES:
            return {
                ...state,
                localization_languages: action.payload
            }
        case actionType.CHANGE_DEFAULT_LANGUAGES:
            return {
                ...state,
                default_languages: action.payload
            }
        default:
            return state    
    };
}
export default localizationReducer;